import i18n from '../../language/index'
import store from '@/vuex/store'
export function basic_searchs_create_style_obj() {
  return [{
    id: '0',
    name: i18n.t('widgets_basic_searchs_patternstyle_2847'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_0',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '1',
    name: i18n.t('widgets_basic_searchs_patternstyle_2848'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_1',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '2',
    name: i18n.t('widgets_basic_searchs_patternstyle_2849'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_2',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(235,235,235,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '3',
    name: i18n.t('widgets_basic_searchs_patternstyle_2850'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_3',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(235,235,235,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '4',
    name: i18n.t('widgets_basic_searchs_patternstyle_2851'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_4',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(235,235,235,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '5',
    name: i18n.t('widgets_basic_searchs_patternstyle_2852'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_5',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(235,235,235,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
        custom: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        }
      }
    }
  },{
    id: '6',
    name: i18n.t('widgets_basic_searchs_patternstyle_2853'),
    borderType: 'withBorder',
    data: {
      styleType: 'type_6',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(235,235,235,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '0',
    name: i18n.t('widgets_basic_searchs_patternstyle_2854'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_0',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '1',
    name: i18n.t('widgets_basic_searchs_patternstyle_2855'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_1',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '2',
    name: i18n.t('widgets_basic_searchs_patternstyle_2856'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_2',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '3',
    name: i18n.t('widgets_basic_searchs_patternstyle_2857'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_3',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '4',
    name: i18n.t('widgets_basic_searchs_patternstyle_2858'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_4',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '5',
    name: i18n.t('widgets_basic_searchs_patternstyle_2859'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_5',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 999,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }, {
    id: '6',
    name: i18n.t('widgets_basic_searchs_patternstyle_2860'),
    borderType: 'solidColor',
    data: {
      styleType: 'type_6',
      borderRadius: {
        radio_val: 'default',
        default: {
          value: 0,
        }
      },
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderTopWidth: 0,
          borderBottomWidth: 0,
          borderStyle: 'solid',
          borderColor: "rgba(239,65,54,1)",
          borderSeColor: "rgba(0, 0, 0,1)",
          checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
        },
      },
      bannerfont: {
        radio_val: 'default',
        default: {
          fontStyle: '',
          fsItalics: 'normal',
          fontUnderline: 'none',
          fontSize: 16,
          fontWidth: 'normal',
          fontColor: 'rgba(51,51,51,1)',
          fontSeColor: 'rgba(153,153,153,1)',
          fontFamily: 'Arial',
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
      },
      bannerbackground: {
        radio_val: 'default',
        default: {
          type: 'color', // 背景设置-类型
          img: '', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
          img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
          tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
          background_size: 'cover',
          background_repeat: 'no-repeat',
          background_position: 'center center' //图片位置
        },
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./src/widgets/basic_searchs/patternStyle.js